import { React, useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  Select,
  Col,
  Row,
  Checkbox,
  Tooltip,
  Radio,
  Dropdown,
  Menu,
} from "antd";
import { Collapse } from 'antd';
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
} from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import { DatePicker } from "antd";
import {
  DatePickerY,
  GlobalSet,
  DisabledStyles,
  DisabledButtonStyle,
  DeliveryaddressSpacing,
} from "../../pageStyled";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertYellow from "../../../Assets/Icons/alertYellow.svg";
import alertBlue from "../../../Assets/Icons/alertBlue.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import warning from "../../../Assets/Icons/warning.png";
import {
  deleteOrder,
  getAllOrdersListByOrderno,
} from "../../../Services/orderServices";
import moment from "moment";
import { ModalPopup } from "../../../Components/Modal/modal";
import { Country, State } from "country-state-city";
import { getProductDetails } from "../../../Services/productServices";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { weightUnit} from "../../../Utils/Constant/MeasurementUnitList";

const { Option } = Select;
const grainTypeData = ["Long Grain", "Short Grain"];
const deckleWidthUnitData = ["mm", "cm"];
const provinceData = ["India", "USA"];
const orderTypeData = [
  { label: "Reel", value: "reel" },
  { label: "Sheet", value: "sheet" },
];
const productSpecData = [
  "Kraft Paper / Corrugated Paper",
  "Duplex Coated Duplex Paper",
  "Writing and Printing Paper",
];
const currencyUnitData = ["US Dollor", "Rupees", "GB Pound"];

const cityData = {
  India: ["Arunachal Pradesh", "Andra Pradesh", "Bihar", "Chhattisgarh"],
  USA: ["Arizona", "California", "Colorado"],
};
const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);
const { TextArea } = Input;
const { Panel } = Collapse;

const EditNewOrderDrawer = (props) => {
  const [checkedBox, setCheckedBox] = useState(false);
  const [cities, setCities] = useState(cityData[provinceData[0]]);
  const [secondCity, setSecondCity] = useState(cityData[provinceData[0]][0]);
  const [orderDetails, setOrderDetails] = useState({});
  const [details, setDetails] = useState({});
  const [form] = Form.useForm();
  const [isVisibleDeleteModal, setIsVisibleDeleteModal] = useState(false);
  const [rewinderDia, setRewinderDia] = useState(false);
  const [validateData, setValidateData] = useState({
    type: "",
    price: "",
    weight: "",
  });
  const [mixedGrain, setMixedGrain] = useState(false);
  const [grainChanges, setGrainChanges] = useState(false);
  const history = useNavigate();

  const orderQuantityTab = details.type && [
    { label: "Weight", value: "weight" },
    { label: `${capitalize(details.type)}s`, value: details.type },
  ];
  const [product, setProduct] = useState([]);
  const handleProvinceChange = (value) => {
    setCities(State.getStatesOfCountry(value));
  };
  const goToPoPage = () => {
    props.onShowPo();
    props.setDrawer(false);
  };
  const onSecondCityChange = (value) => {
    setSecondCity(value);
  };

  const handleType = (e) => {
    setValidateData({ ...validateData, type: e });
  };

  const onFinish = (e) => {
    props.onClose();
    setRewinderDia(false);
  };

  // Delete Action
  const handleDelete = () => {
    setIsVisibleDeleteModal(true);
  };

  // Cancel Action
  const handleCancel = () => {
    props.handleCancel();
    setRewinderDia(false);
    setMixedGrain(false);
    setGrainChanges(false);
  };

  const handleRestore = () => {
    props.handleRestore();
  };

  const onMergeOrderHandler = () => {
   // props.onClose();
    props.setMergeSideDrawer();
  };
  const deleteModalClose = () => {
    setIsVisibleDeleteModal(false);
    props.onClose();
  };
  const deleteModalConfirm = (orderNo) => {
    setIsVisibleDeleteModal(false);
    deleteOrder(orderNo)
      .then((response) => {
        props.isDeleted && props.isDeleted(true);
        props.rendering(true);
        props.toasterAction({
          error: response.error,
          msg: `Order ${orderNo} was successfully deleted`,
        });
        props.showToaster();
      })
      .catch((error) => {
        console.log("Error in deleting order:", error);
        props.toasterAction({
          error: error.response.error,
          msg: error.response.msg,
        });
        props.showToaster();
        props.onClose();
      });
    props.onClose();
  };

  const onChangeCollpase = (key) => {
    // console.log(key);
  };
  useEffect(
    () => {
      props.selectedOrderNo &&
        getAllOrdersListByOrderno(props.selectedOrderNo)
          .then((response) => {
            setOrderDetails(response.data);
            setMixedGrain(response?.data?.grain_mixing);
            setGrainChanges(response?.data?.rotation);
          })
          .catch((error) => {
            console.log(error);
          });
      return () => setOrderDetails({});
    },
    // props.selectedOrder can be passed as the dependency value: results re-endering issue on editing the details
    [props?.selectedOrderNo]
  );

  useEffect(() => {
    form.resetFields();
    setCheckedBox(false);
    orderDetails?.product &&
      getProductDetails(orderDetails.product)
        .then((response) => {
          setProduct(response.data);
        })
        .catch((error) => {
          console.log("Error in product data loading:", error);
        });
    return () => {
      setProduct({});
    };
  }, [orderDetails]);

  useEffect(() => {
    // the drawer is opening two times (rendering the product data)
    if (Object.keys(product).length && Object.keys(orderDetails).length) {
      setRewinderDia(false);
      if(orderDetails?.reel_diameter === "multiple"){
        setRewinderDia(true);
      }
      setDetails({
        orderno: orderDetails.number,
        pono: orderDetails.po,
        productSpec: orderDetails.product_spec,
        type: orderDetails.type?.toLowerCase(),
        grain: orderDetails.grain,
        length: orderDetails.length,
        width: orderDetails.width,
        weight: parseFloat(orderDetails.weight).toFixed(3),
        quantity: orderDetails.type === "reel" &&
        orderDetails.quantity_type === "reel_sheet" ? parseInt(orderDetails.no_of_reel_sheet) : orderDetails.quantity ? orderDetails.quantity : 0,        // rewinder_reels: orderDetails.rewinder_reels,
        core_od: orderDetails.core_id ? orderDetails.core_id : "",
        reel_od: orderDetails.reel_od ? orderDetails.reel_od : "",
        price: parseFloat(orderDetails.quoted_price)
          ? parseFloat(orderDetails.quoted_price).toFixed(3)
          : "",
        net_price: parseFloat(orderDetails.net_price)
          ? parseFloat(orderDetails.net_price).toFixed(3)
          : "",
        currency: orderDetails.currency,
        delivery_date: moment(orderDetails.delivery_date).format("DD MM YYYY"),
        delivery_address_line_1: orderDetails.delivery_address_line_1,
        delivery_address_line_2: orderDetails.delivery_address_line_2,
        delivery_state: orderDetails.delivery_state,
        delivery_city: orderDetails.delivery_city,
        delivery_pincode: orderDetails.delivery_pincode,
        delivery_country: orderDetails.delivery_country,
        remarks: orderDetails.remarks,
        priority: orderDetails.forced,
        state: orderDetails.state,
        product_code: `${orderDetails.product} - ${product.name}`,
        productUnit: product.units,
        quantityType: orderDetails.quantity_type,
        plannedWeight:
          orderDetails.planned_weight != 0
            ? orderDetails.planned_weight?.toFixed(3)
            : 0,
        no_of_reel_sheet: parseInt(orderDetails.no_of_reel_sheet),

        comment: orderDetails.comments.length
          ? orderDetails.comments[orderDetails.comments.length - 1]
          : "",
        completed: orderDetails.completed,
        inProcess: orderDetails.in_process,
        inProduction: orderDetails.in_production,
        reel_diameter: orderDetails?.reel_diameter,
        split_type: orderDetails?.split_type,
        lower_tolerance: orderDetails?.lower_tolerance ? orderDetails?.lower_tolerance?.toFixed(3) : 0.000,
        upper_tolerance: orderDetails?.upper_tolerance ? orderDetails?.upper_tolerance?.toFixed(3) : 0.000,
        calculated_lower_tolerance: orderDetails?.calculated_lower_tolerance ? orderDetails?.calculated_lower_tolerance?.toFixed(3) : 0.000,
        calculated_upper_tolerance: orderDetails?.calculated_upper_tolerance ? orderDetails?.calculated_upper_tolerance?.toFixed(3) : 0.000,
        units: orderDetails?.units
      });
    }
    return () => {
      setDetails({});
    };
  }, [product]);
  // console.log("s", orderDetails);
  const onViewChangeHandler = () => {
    console.log("history");
    history("../history", {
      state: {
        order: {
          orderDetails: props.selectedOrder,
          route: props.pageType === "orderRecord" ? "../order-records" : props.pageType === "approveOrder" ? "../approve-records" : "../order-details",
          PORoute : props?.route ,
          backKey : props?.backKey ,
          values : props?.values,
          defaultActiveKey : props?.defaultActiveKey,
          defaultOrderState : props?.defaultOrderState
        },
        logType: "Order",
        name: props.selectedOrder.orderno,
        searchText: "Search change in order property",
      },
    });
  };
  return details.type ? (
    <RightDrawerSidebar
      title={`Order Details - #${details?.orderno}`}
      subtitle=""
      visible={props.visible}
      onClose={() => {
        props.onCloseGrade();
        setMixedGrain(false);
        setGrainChanges(false);
        setRewinderDia(false);
      }}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <DetailFields className="marginBtnP">
            <HaberForm>
              {(details.priority ||
                ["rejected", "review", "hold", "cancel"].includes(
                  details.state
                )) && (
                <div className="drawerFieldAlert">
                  <div
                    className="titleWithText"
                    style={{
                      marginBottom: 20,
                    }}
                  >
                    {/* Priority Order means need to show this blue alert box */}
                    {details.priority && (
                      <>
                        <h5
                          style={{
                            paddingTop: 0,
                            paddingBottom: 20,
                          }}
                        >
                          Priority Order
                        </h5>
                        <AlertContainer
                          color="blue"
                          icon={alertBlue}
                          msg="This Order is prioritized by the approver"
                        />
                      </>
                    )}
                    {details.state !== "open" &&
                      // details.state !== "review" &&
                      details.state !== "approved" &&
                      details.comment && (
                        <>
                          <h5
                            style={{
                              paddingTop: 0,
                              paddingBottom: 20,
                            }}
                          >
                            {details.state === "review"
                              ? "Requested Changes"
                              : details.state === "rejected"
                              ? "Reason for Rejection"
                              : details.state === "hold"
                              ? "Reason for Holding Order"
                              : details.state === "cancel"
                              ? "Reason for Cancelling Order"
                              : ""}
                          </h5>
                          {/* {details.state === "review" && ( */}
                          <AlertContainer
                            color={
                              details.state === "review" ? "yellow" : "red"
                            }
                            icon={
                              details.state === "review"
                                ? alertYellow
                                : alertRed
                            }
                            msg={details.comment}
                          />
                        </>
                      )}
                  </div>
                </div>
              )}

              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "10" }}
                onFinish={onFinish}
                form={form}
              >
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Order Number</h5>
                    <p>A unique auto-generated code to identify this order</p>
                  </div>
                  <Form.Item
                    name="pono"
                    rules={[{ required: true }]}
                    className=""
                    initialValue={details?.orderno}
                  >
                    <Input disabled placeholder="Enter PO Number" />
                  </Form.Item>
                </div>
                {/* Product name */}
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Product Name</h5>
                    <p>Unique name to identify the product</p>
                  </div>
                  <Form.Item
                    name="product_code"
                    rules={[{}]}
                    className="selectForm"
                    initialValue={details?.product_code}
                  >
                    <Select
                      placeholder="Select Product"
                      suffixIcon={<DownArrowDraw />}
                      //  onChange={handleProduct}
                      disabled
                    >
                      <Option key={details?.product_code}>
                        {details?.product_code}
                      </Option>
                    </Select>
                  </Form.Item>
                </div>

                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Product Specifications</h5>
                    <p>Combination of Grade/GSM/BF/Quality/Moisture</p>
                  </div>
                  <Form.Item
                    name="product_spec"
                    rules={[{}]}
                    initialValue={details?.productSpec}
                    className="selectForm"
                  >
                    <Select
                      placeholder="Select"
                      disabled
                      suffixIcon={<DownArrowDraw />}
                    >
                      {productSpecData.map((productSpec) => (
                        <Option key={productSpec}>{productSpec}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Order type</h5>
                    <p>The order can be of reel or sheet type</p>
                  </div>
                  <Form.Item
                    name="type"
                    rules={[{ required: true }]}
                    className="selectForm"
                    initialValue={details.type}
                  >
                    <Select
                      placeholder="Select"
                      suffixIcon={<DownArrowDraw />}
                      disabled
                      onChange={handleType}
                    >
                      {orderTypeData.map((orderType) => (
                        <Option key={orderType.value}>{orderType.label}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                {details.type !== "reel" && (
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Grain</h5>
                      <p>The order can be of long or short grain</p>
                    </div>
                    <Form.Item
                      name="grain"
                      rules={[{ required: true }]}
                      className="selectForm"
                      initialValue={
                        details.grain ? capitalize(details.grain) : null
                      }
                    >
                      <Select
                        placeholder={"Select"}
                        suffixIcon={<DownArrowDraw />}
                        disabled
                      >
                        {grainTypeData.map((grainType) => (
                          <Option key={grainType}>{grainType}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Col span={24} style={{marginTop:"-16px"}}>
                      <Row className="centerAlign justifyCSBetween">
                        <Col>
                              <Checkbox
                                disabled={true}                           
                                checked={mixedGrain}
                              ></Checkbox>
                              <span
                                style={{
                                  marginLeft: "5px",
                                  fontSize: "12px",
                                  fontWeight: "500",
                                  fontSize: "12px",
                                  fontFamily: "var(--sf-pro-text)",
                                  color: "var(--color-text-title)",
                                  lineHeight: "20px"
                                }}
                              >
                                Allow mixed grain for this order
                              </span>
                            </Col>
                      </Row>
                    </Col>
                    <Col span={24} style={{marginBottom:"8px"}}>
                      <Row className="centerAlign justifyCSBetween">
                        <Col>
                              <Checkbox
                                disabled={true}                           
                                checked={grainChanges}
                              ></Checkbox>
                              <span
                                style={{
                                  marginLeft: "5px",
                                  fontSize: "12px",
                                  fontWeight: "500",
                                  fontSize: "12px",
                                  fontFamily: "var(--sf-pro-text)",
                                  color: "var(--color-text-title)",
                                  lineHeight: "20px"
                                }}
                              >
                                Allow grain changes for this order
                              </span>
                            </Col>
                      </Row>
                    </Col>
                  </div>
                )}
                <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>Order Dimension</h5>
                    <p>
                      {validateData.type === "Reel" ? (
                        <>The width of the order</>
                      ) : (
                        <>The width and length of the order</>
                      )}
                    </p>
                  </div>
                  <Row className="centerAlign justifyCSBetween">
                    {details.type !== "reel" && (
                      <Col span={8}>
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <Form.Item
                            label="Length"
                            name="length"
                            rules={[
                              {
                                required:
                                  validateData.type !== "Reel" ? true : false,
                              },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                                message:
                                  "Upto 2 decimal point values is accepted",
                              },
                            ]}
                            className="dBlock"
                            initialValue={details.length}
                          >
                            <Input placeholder="Length" disabled />
                          </Form.Item>
                        </div>
                      </Col>
                    )}
                    <Col span={details.type !== "reel" ? 8 : 16}>
                      <div className="boxFormType">
                        <Form.Item
                          label="Width"
                          name="width"
                          rules={[
                            { required: true },
                            {
                              pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                              message:
                                "Upto 2 decimal point values is accepted",
                            },
                          ]}
                          className="dBlock"
                          initialValue={details.width}
                        >
                          <Input placeholder="Width" disabled />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={7}>
                      <div className="boxFormType unitSelect">
                        <Form.Item
                          label="Unit"
                          name="dimension-unit"
                          rules={[{ required: true }]}
                          className="dBlock"
                          initialValue={details.units.width}
                        >
                          <Select
                            placeholder="Unit"
                            suffixIcon={<DownArrowDraw />}
                            disabled
                          >
                            {deckleWidthUnitData.map((deckleWidth) => (
                              <Option
                                key={deckleWidth.value}
                                value={deckleWidth.value}
                              >
                                {deckleWidth}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Order Quantity</h5>
                    <p>Order format and quantity</p>
                  </div>
                  <div
                    className="switchRadio twoSwitch"
                    style={{ justifyContent: "center", display: "flex" }}
                  >
                    <Radio.Group
                      disabled
                      options={orderQuantityTab}
                      optionType="button"
                      buttonStyle="solid"
                      value={
                        details.quantityType === "weight"
                          ? "weight"
                          : details.type
                      }
                    />
                  </div>
                  {details.quantityType === "weight" ? (
                    <>
                      <div className="subTitleWithText">
                        <p>Weight of order</p>
                      </div>
                      <div style={{ position: "relative" }}>
                        <Row className="centerAlign justifyCSBetween">
                            <Col span={13}>
                              <div className="boxFormType">
                              <Form.Item
                          name="weight"
                          rules={[
                            { required: true },
                            {
                              pattern: new RegExp(/^\d+(\.\d+)?$/),
                              message: "Only decimal characters are allowed",
                            },
                          ]}
                          className=""
                          initialValue={parseFloat(details.weight).toFixed(3)}
                        >
                          <Input placeholder="Enter weight" disabled />
                        </Form.Item>
                              </div>
                            </Col>
                            <Col span={10}>
                              <div className="boxFormType ">
                                <Form.Item
                                name="weightUnit"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                ]}
                                className="dBlock"
                                initialValue={weightUnit[details.units.weight]?.displayName}
                              ><Input disabled />
                                </Form.Item>
                              </div>
                            </Col>
                          </Row>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="subTitleWithText">
                        <p>{`Number of ${details.type}s`}</p>
                      </div>
                      <Form.Item
                        name="quantity"
                        rules={[
                          { required: true },
                          {
                            pattern: new RegExp(/^[0-9]+$/),
                            message: "Only Numeric value is possible",
                          },
                        ]}
                        className=""
                        // initialValue={details.quantity}
                        initialValue={
                          details?.type === "reel"
                            ? details.quantity
                            : details.no_of_reel_sheet
                        }
                      >
                        <Input placeholder="Enter quantity" disabled />
                      </Form.Item>
                    </>
                  )}
                </div>
                <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>Rewinder Dimensions</h5>
                    <p>The outer diameter of the reel and rewinder core</p>
                  </div>
                  <Col span={24}>
                  <Row className="centerAlign justifyCSBetween">
                      <Col>
                            <Checkbox
                              disabled={true}                           
                              checked={rewinderDia}
                            ></Checkbox>
                            <span
                              style={{
                                marginLeft: "5px",
                                fontSize: "12px",
                                fontWeight: "500",
                                fontSize: "12px",
                                fontFamily: "var(--sf-pro-text)",
                                color: "var(--color-text-title)",
                                lineHeight: "20px"
                              }}
                            >
                              Allow multiple rewinder dia in production
                            </span>
                          </Col>
                    </Row>
                    <Row style={{ marginTop: "8px"}} className="centerAlign  justifyCSBetween">
                      <Col span={8} className="blockBreak">
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <Form.Item
                            label="Core OD"
                            name="core_od"
                            rules={[
                              { required: true },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                                message: "Only Numeric value is possible",
                              },
                            ]}
                            className="dBlock"
                            initialValue={details.core_od}
                          >
                            <Input placeholder="For Core OD" disabled />
                          </Form.Item>
                        </div>
                      </Col>
                      <Col span={8} className="blockBreak">
                        <div className="boxFormType">
                          <Form.Item
                            label="Reel OD"
                            name="reel_od"
                            rules={[
                              { required: true },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                                message: "Only Numeric value is possible",
                              },
                            ]}
                            className="dBlock"
                            initialValue={details.reel_od}
                          >
                            <Input placeholder="For Reel OD" disabled />
                          </Form.Item>
                        </div>
                      </Col>
                      <Col span={7} className="blockBreak">
                        {/* <label className="labelSel">Unit</label> */}
                        <div className="boxFormType unitSelect">
                          <Form.Item
                            label="Unit"
                            name="unit"
                            rules={[{ required: true }]}
                            className="dBlock"
                            initialValue={details.units.core_id}
                          >
                            <Select
                              placeholder="Unit"
                              label="Unit"
                              suffixIcon={<DownArrowDraw />}
                              className="dBlock"
                              disabled
                            >
                              {deckleWidthUnitData.map((deckleWidth) => (
                                <Option
                                  key={deckleWidth.value}
                                  value={deckleWidth.value}
                                >
                                  {deckleWidth}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
                {((orderDetails?.type === "sheet" && orderDetails?.core_id && orderDetails?.reel_od) || orderDetails?.type === "reel") && <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Planned Number of Rewinder Reels</h5>
                    <p>
                      The number of rewinder reels required to fulfill the order
                    </p>
                  </div>
                  <Form.Item
                    name="no_of_reel_sheet"
                    rules={[
                      {
                        required: true,
                      },
                      {
                        pattern: new RegExp(/^[0-9]+$/),
                        message: "Only Numeric value is possible",
                      },
                    ]}
                    className=""
                    initialValue={details.quantity} //quantity
                  >
                    <Input placeholder="Enter the number of reels" disabled />
                  </Form.Item>
                </div>}
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Planned Weight</h5>
                    <p>
                      Calculated weight of order for planned number of reels
                    </p>
                  </div>
                  <div style={{ position: "relative" }}>
                    <Form.Item
                      name="planned_weight"
                      rules={[]}
                      className=""
                      initialValue={parseFloat(details.plannedWeight).toFixed(3)}
                    >
                      <Input disabled />
                    </Form.Item>
                    <span className="nonEditable">{weightUnit[details.units.planned_weight]?.displayName}</span>
                  </div>
                  {details?.type === "sheet" && !orderDetails?.core_id && !orderDetails?.reel_od && (
                      <Collapse 
                        onChange={onChangeCollpase}
                        expandIconPosition="right"
                        bordered={false}
                        style={{backgroundColor: "white", marginTop:"-18px"}}>
                        <Panel
                          header={"Tolerance -" + details?.upper_tolerance + " to +"+ details?.lower_tolerance  +" %"}
                          style={{ fontStyle: "italic" , marginLeft:"-12px"}}
                        >
                          <Row
                            style={{ marginTop: "3px" }}
                            className="centerAlign  justifyCSBetween"
                          >
                            <Col span={8} className="blockBreak">
                              <div className="titleWithText">
                                <p style={{marginTop:"7px", fontStyle: "initial", fontSize: "12px", fontFamily: "var(--sf-pro-text)",
                                 color: "var(--color-text-title)", lineHeight: "20px", }}>Upper Tolerance </p>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                              <div
                                className="boxFormType"
                                style={{ marginBottom: "0" }}
                              >
                                <Form.Item
                                  label=""
                                  name="upper_tolerance"
                                  rules={[
                                    {
                                      pattern: new RegExp(/^\d+(\.\d{0,5})?$/),
                                      message: "Only Numeric value is possible",
                                    },
                                    {
                                        required: true,
                                        message: "This field is required",
                                    },
                                  ]}
                                  className="dBlock"
                                  initialValue={details?.upper_tolerance}
                                >
                                  <Input
                                    placeholder=""
                                    style={{fontSize:"10px",height:"30px"}}
                                    disabled
                                  />
                                </Form.Item>
                                <span className="nonEditable" style={{fontize: "13px", top:"5px"}}>%</span>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                            <Col span={8} className="blockBreak" style={{maxWidth:"45%", marginLeft:"15px"}}>
                              <div className="titleWithText">
                                <p style={{fontSize: "12px", fontFamily: "var(--sf-pro-text)",
                                 color: "var(--color-text-title)", lineHeight: "20px",
                                  marginTop:"7px",fontStyle: "initial", width:"104px"}}>{details?.calculated_upper_tolerance + " "} {weightUnit[details?.units.calculated_upper_tolerance]?.displayName}</p>
                              </div>
                            </Col>
                            </Col>
                          </Row>
                          
                          <Row
                            style={{ marginTop: "0px" }}
                            className="centerAlign  justifyCSBetween"
                          >
                            <Col span={8} className="blockBreak">
                              <div className="titleWithText">
                                <p style={{marginTop:"7px", fontStyle: "initial", fontSize: "12px", fontFamily: "var(--sf-pro-text)",
                                 color: "var(--color-text-title)", lineHeight: "20px", }}>Lower Tolerance </p>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                              <div
                                className="boxFormType"
                                style={{ marginBottom: "0" }}
                              >
                                <Form.Item
                                  label=""
                                  name="lower_tolerance"
                                  rules={[
                                    {
                                      pattern: new RegExp(/^\d+(\.\d{0,5})?$/),
                                      message: "Only Numeric value is possible",
                                    },
                                    {
                                        required: true,
                                        message: "This field is required",
                                    },
                                  ]}
                                  className="dBlock"
                                  initialValue={details?.lower_tolerance}
                                >
                                  <Input
                                    placeholder=""
                                    style={{fontSize:"10px", height:"30px"}}
                                    disabled
                                  />
                                </Form.Item>
                                <span className="nonEditable" style={{fontize: "13px", top:"5px"}}>%</span>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                            <Col span={8} className="blockBreak" style={{maxWidth:"45%", marginLeft:"15px"}}>
                              <div className="titleWithText">
                                <p style={{fontSize: "12px", fontFamily: "var(--sf-pro-text)",
                                 color: "var(--color-text-title)", lineHeight: "20px",
                                  marginTop:"7px",fontStyle: "initial", width:"104px"}}>{details?.calculated_lower_tolerance+ " "} {weightUnit[details?.units.calculated_lower_tolerance]?.displayName}</p>
                              </div>
                            </Col>
                            </Col>
                          </Row>
                        </Panel>
                      </Collapse>
                    )}
                </div>
                <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>Price</h5>
                    <p>Price per unit weight of the order</p>
                  </div>
                  <Row className="centerAlign  justifyCSBetween">
                  <Col style={{paddingRight:'5px'}} span={9}>
                      <div
                        className="boxFormType"
                        style={{ marginBottom: "0" }}
                      >
                        <Form.Item
                          label={"Price" + " / " + weightUnit[details?.productUnit?.per_weight_unit]?.displayName}
                          name="price"
                          rules={[
                            { required: true },
                            {
                              pattern: new RegExp(/^\d+(\.\d+)?$/),
                              message: "Only decimal values possible",
                            },
                          ]}
                          className="dBlock"
                          initialValue={details.price}
                        >
                          <Input placeholder="Price per Tonne" disabled />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col style={{paddingRight:'5px'}} span={6}>
                      <div className="boxFormType unitSelect">
                        <Form.Item
                          label="Currency"
                          name="currency"
                          rules={[{}]}
                          initialValue={details?.units.quoted_price}
                          className="dBlock"
                        >
                          <Select
                            placeholder="Currency"
                            suffixIcon={<DownArrowDraw />}
                            disabled
                          >
                            {currencyUnitData.map((currencyUnit) => (
                              <Option key={currencyUnit} value={currencyUnit}>
                                {currencyUnit}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={9}>
                      <div className="boxFormType">
                        <Form.Item
                          label="Net Price"
                          name="net_price"
                          rules={[{}]}
                          className="dBlock"
                          initialValue={details.net_price}
                        >
                          <Input placeholder="Net Price" disabled />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Delivery Date</h5>
                    <p>Date when order needs to be delivered</p>
                  </div>
                  <div className="boxFormType">
                    <DatePickerY>
                      <Form.Item
                        name="delivery_date"
                        initialValue={moment(
                          details.delivery_date,
                          "DD MM YYYY"
                        )}
                      >
                        <DatePicker disabled format={"DD/MM/YYYY"} />
                      </Form.Item>
                    </DatePickerY>
                  </div>
                </div>
                <div className="drawerField" style={{ paddingBottom: "20px" }}>
                  <div className="titleWithText">
                    <h5>Delivery Address</h5>
                    <p>The postal address where order needs to be delivered</p>
                  </div>
                  <Col span={24}>
                    <Row className="centerAlign">
                      <DeliveryaddressSpacing>
                        <Col
                          span={24}
                          className="blockBreak haberdeliveryaddress"
                        >
                          <div className="boxFormType">
                            <Form.Item name="Contactaddress" className="">
                              <DisabledStyles>
                                <Form.Item
                                  name="delivery_address_line_1"
                                  rules={[
                                    { required: true },
                                    { max: 50, message: "Maximum length: 50" },
                                  ]}
                                  initialValue={
                                    details?.delivery_address_line_1
                                  }
                                  className=""
                                >
                                  <Input
                                    disabled
                                    className="disabled-check"
                                    placeholder="First Line of address"
                                  />
                                </Form.Item>
                              </DisabledStyles>
                            </Form.Item>
                          </div>

                          <div className="boxFormType">
                            <Form.Item
                              name="contact_address"
                              rules={[
                                { max: 50, message: "Maximum length: 50" },
                              ]}
                              className=""
                            >
                              <DisabledStyles>
                                <Form.Item
                                  name="delivery_address_line_2"
                                  rules={[{}]}
                                  initialValue={
                                    details?.delivery_address_line_2
                                  }
                                  className=""
                                >
                                  <Input
                                    disabled
                                    className="disabled-check"
                                    placeholder="Second Line of address"
                                  />
                                </Form.Item>
                              </DisabledStyles>
                            </Form.Item>
                          </div>

                          <Col span={12} className="d-flex">
                            <div className="boxFormType">
                              <DisabledStyles>
                                <Form.Item
                                  name="delivery_country"
                                  rules={[{ required: true }]}
                                  initialValue={details?.delivery_country}
                                  className=""
                                >
                                  <Select
                                    className="disabled-check"
                                    disabled
                                    suffixIcon={<DownArrowDraw />}
                                    defaultValue={provinceData[0]}
                                    onChange={handleProvinceChange}
                                    placeholder="Country"
                                  >
                                    {Country.getAllCountries().map(
                                      (province) => (
                                        <Option key={province.isoCode}>
                                          {province.name}
                                        </Option>
                                      )
                                    )}
                                  </Select>
                                </Form.Item>
                              </DisabledStyles>
                            </div>
                            <div className="boxFormType">
                              <DisabledStyles>
                                <Form.Item
                                  name="delivery_state"
                                  rules={[{ required: true }]}
                                  initialValue={details?.delivery_state}
                                  className=""
                                >
                                  <Select
                                    disabled
                                    suffixIcon={<DownArrowDraw />}
                                    value={secondCity}
                                    onChange={onSecondCityChange}
                                    placeholder="State"
                                  >
                                    {cities.map((city) => (
                                      <Option key={city.name}>
                                        {city.name}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </DisabledStyles>
                            </div>
                          </Col>
                          <Col span={12} className="d-flex">
                            <div
                              className="boxFormType"
                              style={{ marginBottom: "0" }}
                            >
                              <DisabledStyles>
                                <Form.Item
                                  name="delivery_city"
                                  rules={[
                                    { required: true },
                                    { max: 50, message: "Maximum length: 50" },
                                  ]}
                                  className=""
                                  initialValue={details?.delivery_city}
                                >
                                  <Input
                                    placeholder="City"
                                    disabled
                                    className="disabled-check"
                                    style={{ textTransform: "capitalize" }}
                                  />
                                </Form.Item>
                              </DisabledStyles>
                            </div>
                            <div className="boxFormType">
                              <DisabledStyles>
                                <Form.Item
                                  name="zip_code"
                                  rules={[
                                    { required: true },
                                    { min: 6, message: "Minimum length: 6" },
                                    { max: 6, message: "Maximum length: 6" },
                                    {
                                      pattern: new RegExp(/^[0-9]+$/),
                                      message: "Only Numeric value is possible",
                                    },
                                  ]}
                                  className=""
                                  initialValue={details?.delivery_pincode}
                                >
                                  <Input
                                    disabled
                                    className="disabled-check"
                                    placeholder="ZIP code"
                                  />
                                </Form.Item>
                              </DisabledStyles>
                            </div>
                          </Col>
                        </Col>
                      </DeliveryaddressSpacing>
                    </Row>
                  </Col>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Remarks</h5>
                    <p>Any other Information related to the order</p>
                  </div>
                  <Form.Item
                    name="remarks"
                    rules={[{ required: true }]}
                    className=""
                    initialValue={details.remarks}
                  >
                    <TextArea
                      maxLength={100}
                      style={{ height: 90 }}
                      placeholder="Add Remarks"
                      disabled
                    />
                  </Form.Item>
                </div>
                <div
                  className="buttonFlex fixedBtm"
                  style={{ flexDirection: "row" }}
                >
                  {details.state !== "cancel" && (props.roles.edit_own || props.roles.edit_all) ? (
                    <Form.Item>
                      <Tooltip
                        title={
                          props?.selectedOrder?.priority &&
                          "Priority orders cannot be merged"
                        }
                      >
                        <DisabledButtonStyle>
                          {details.split_type != "auto" && (<Button
                            //htmlType="submit"
                            className="themeBtn  "
                            disabled={
                              props?.selectedOrder?.status !== "Approved" ||
                              props?.selectedOrder?.priority ||
                              props?.selectedOrder?.completed != 0 ||
                              props?.selectedOrder?.in_production != 0 ||
                              props?.selectedOrder?.in_process != 0 ||
                              !props?.selectedOrder?.parent
                            }
                            onClick={onMergeOrderHandler}
                          >
                            <Iconmoon
                              icon="export"
                              color="#ffffff"
                              size={16}
                              style={{
                                color:
                                  props?.selectedOrder?.status !== "Approved" ||
                                  props?.selectedOrder?.priority ||
                                  props?.selectedOrder?.completed != 0 ||
                                  props?.selectedOrder?.in_production != 0 ||
                                  props?.selectedOrder?.in_process != 0 ||
                                  !props?.selectedOrder?.parent
                                    ? "#A19F9D"
                                    : "#ffffff",
                              }}
                            />
                            <span
                              style={{
                                color:
                                  props?.selectedOrder?.status !== "Approved" ||
                                  props?.selectedOrder?.priority ||
                                  props?.selectedOrder?.completed != 0 ||
                                  props?.selectedOrder?.in_production != 0 ||
                                  props?.selectedOrder?.in_process != 0 ||
                                  !props?.selectedOrder?.parent
                                    ? "#A19F9D"
                                    : "#ffffff",
                              }}
                            >
                              {" "}
                              Merge Order
                            </span>{" "}
                          </Button>)}
                        </DisabledButtonStyle>
                      </Tooltip>
                    </Form.Item>
                  ) : (
                   (props.roles.edit_own || props.roles.edit_all)&& (
                      <Form.Item>
                        <Button
                          //htmlType="submit"
                          className="themeBtn"
                          onClick={() => handleRestore()}
                        >
                          <Iconmoon icon="export" size={16} color="#ffffff" />
                          Restore Order{" "}
                        </Button>
                      </Form.Item>
                    )
                  )}
                  {props.roles && (
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      {(!["Open", "Rejected", "Cancelled", "Complete", "cancel", "rejected","complete","Merged"].includes(
                        props.selectedState
                      ) && (props.roles.edit_own || props.roles.edit_all)) &&
                        details.completed == 0 &&
                        details.inProcess == 0 &&
                        details.inProduction == 0 &&
                        !details.priority && (
                          <Form.Item>
                            <DisabledButtonStyle>
                              <Button
                                style={{
                                  padding: "0px 0px 0px 0px",
                                  margin: "0px 10px 0px 0px",
                                }}
                                className="themeBtn noBg active"
                                // disabled={details.state !== "pending"}
                                onClick={() => handleCancel()}
                              >
                                <Iconmoon
                                  icon="wrong"
                                  size={16}
                                  color="#A19F9D"
                                />{" "}
                                Cancel{" "}
                              </Button>
                            </DisabledButtonStyle>
                          </Form.Item>
                        )}
                      {
                      (props.roles.edit_own || props.roles.edit_all ? (
                      <Form.Item>
                        <Dropdown
                          overlay={
                            <Menu>
                              {
                                <Tooltip
                                  title={
                                    details.state !== "open" &&
                                    "This order is processed and cannot be deleted"
                                  }
                                >
                                  <Menu.Item key="1">
                                    <DisabledButtonStyle>
                                      <Button
                                        style={{
                                          border: "none",
                                          background: "none",
                                          padding: "0",
                                          font: "inherit",
                                          textAlign: "left",
                                          width: "100%",
                                        }}
                                        disabled={details.state !== "open"}
                                        onClick={() => handleDelete()}
                                      >
                                        <span
                                          style={{
                                            color:
                                              details.state !== "open"
                                                ? "#A19F9D"
                                                : "rgba(0, 0, 0, 0.85)",
                                          }}
                                        >
                                          Delete
                                        </span>
                                      </Button>
                                    </DisabledButtonStyle>
                                  </Menu.Item>
                                </Tooltip>
                              }
                              <Menu.Item key="2">
                                <DisabledButtonStyle>
                                  <Button
                                    onClick={onViewChangeHandler}
                                    style={{
                                      border: "none",
                                      background: "none",
                                      color: "inherit",
                                      padding: "0",
                                      font: "inherit",
                                      cursor: "pointer",
                                      outline: "inherit",
                                      textAlign: "left",
                                    }}
                                  >
                                    View Change History
                                  </Button>{" "}
                                </DisabledButtonStyle>
                              </Menu.Item>
                            </Menu>
                          }
                          placement="top"
                          arrow
                        >
                          <Button
                            style={{
                              margin: "0px 10px 0px 0px",
                              padding: "4px 12px",
                            }}
                            className="themeBtn noBg active"
                            // disabled={details.state !== "pending"}
                          >
                            <span style={{ margin: "0px" }}>More Actions </span>
                          </Button>
                        </Dropdown>
                      </Form.Item>
                      ): <Form.Item>
                      <Dropdown
                        overlay={
                          <Menu>
                            <Menu.Item key="1">
                              <DisabledButtonStyle>
                                <Button
                                  onClick={onViewChangeHandler}
                                  style={{
                                    border: "none",
                                    background: "none",
                                    color: "inherit",
                                    padding: "0",
                                    font: "inherit",
                                    cursor: "pointer",
                                    outline: "inherit",
                                    textAlign: "left",
                                  }}
                                >
                                  View Change History
                                </Button>{" "}
                              </DisabledButtonStyle>
                            </Menu.Item>
                          </Menu>
                        }
                        placement="top"
                        arrow
                      >
                        <Button
                          style={{
                            margin: "0px 10px 0px 0px",
                            padding: "4px 12px",
                          }}
                          className="themeBtn noBg active"
                          // disabled={details.state !== "pending"}
                        >
                          <span style={{ margin: "0px" }}>More Actions </span>
                        </Button>
                      </Dropdown>
                    </Form.Item>
                      )}
                    </div>
                  )}
                </div>
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
      </RightDrawerContainer>

      {/* Delete confirmation modal */}
      <ModalPopup visible={isVisibleDeleteModal}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Delete Order?</span>
          <p>
            You will not be able to recover the order if you delete it. Are you
            sure you want to proceed?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => deleteModalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => deleteModalConfirm(props.selectedOrderNo)}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>
    </RightDrawerSidebar>
  ) : null;
};

export default EditNewOrderDrawer;
